<template>
<section v-if="hasPermissions(['Report Read', 'Report Write'])" class="view">
    <Breadcrumb :breadcrumb="breadcrumb" />
    <h1 class="view__title title--1" v-html="title_page" />
    <div class="view__description">
        <p class="view__description__text">
        </p>
    </div>
    <div class="row">
        <div class="col-md-6">
            <FormDynamic :form_format="form_format" :form_data="form_data" :array_options="array_options" :content_align_x="'xx'">
                <template v-slot:more-fields>
                    <div class="formdynamic__item col-md-4 pl-2 py-0">
                        <label for="Assigned Frequency:" class="modal-label" v-html="'Assigned Frequency:'"/>
                        <div class="row mb-0">
                            <div class="col-md-3 py-0">
                                <div class="formdynamic__item__field">
                                    <select size="" class="input-field custom-select" v-model="form_data.assigned_frequency_symbol">
                                        <option v-for="(item, i) in symbol_options" :key="i" :value="item.id" v-html="item.name"/>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-9 py-0">
                                <div class="formdynamic__item__field">
                                    <input type="number" :min="0" class="form-control" v-model="form_data.assigned_frequency"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </FormDynamic>
            <a :class="{'disabled button__disabled' : searching_levels || searching_areas}" class="modal__buttons__item w-auto px-3 mt-3" v-html="'Generate Report'" @click="getReport()"/>
        </div>
    </div>
    <div class="tab-content mt-5" v-show="pdfSource">
        <div class="tab-pane fade active show" id="listation">
            <div class="row mb-0 no-gutters justify-content-md-center">
                <div class="col-lg-10" style="min-height: 60rem">
                    <v-card style="height: 100%">
                        <div>
                            <iframe style="width: 100%; height: 60rem;" :src="pdfSource"></iframe>
                        </div>
                    </v-card>
                </div>
            </div>
        </div>
    </div>
    <WaitingModal />
</section>

<div v-else>
    <UnauthorizedComponent :breadcrumb="breadcrumb" />
</div>
</template>

    
            
        
    
<script>
import axios from 'axios';
import Resources from './resources'
import FormResources from './form_resources'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal from '@/components/WaitingModal'
import UnauthorizedComponent from '@/components/UnauthorizedComponent'
import { Notyf } from 'notyf'
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'
import FormDynamic from '@/components/FormDynamic.vue';
const notyf = new Notyf({
    duration: 8000,
});
import _ from 'lodash'

export default {

    name: "DailyAssignmentRooms",

    components: {
        Breadcrumb,
        WaitingModal,
        UnauthorizedComponent,
        FormDynamic
    },

    data() {
        return {
            notyf,
            axios,
            user: this.get_user(),
            rest_api: `search_standard_reports`,
            title_page: 'Over / Under / Unassigned Rooms',
            title_for_breadcrumb: 'Over - Under - Unassigned Rooms',
            current_url: `/reports`,
            breadcrumb: JSON.parse(JSON.stringify(Resources.breadcrumb)),
            form_format: FormResources.form_format_daily_assignment_rooms,
            form_data: FormResources.form_data_daily_assignment_rooms,
            daily_assignment_rooms_table: Resources.daily_assignment_rooms_table,
            daily_assignment_rooms_table_2: Resources.daily_assignment_rooms_table_2,
            symbol_options: FormResources.simbol_options,
            search: '',
            first_request: true,
            pdfSource: '',
            standard_report_id: 27,
            array_options: {
                status_id: [],
                radio: [],
                building_id: [],
                level_id: [],
                area_id: []
            },
            searching_levels: false,
            searching_areas: false
        };
    },

    methods: {

        backToReports() {
            window.location.href = '/reports'
        },

        async getInitialData(loader = true) {
            const form_data = {
                module_id: this.standard_report_id,
                first_request: loader,
                building_id: this.form_data.building_id,
                level_id: this.form_data.level_id,
                task_type: this.form_data.task_type_id
            }

            this.loader(loader)

            const response = await this.post('params_standard_reports', form_data)

            if (response.status) {
                if(loader)
                {
                    this.fill_data(response.data)
                }
                else
                {
                    const task_ids = new Set(this.form_data.task_id.map(item => item));
                    this.form_data.task_id = response.data.task_id.filter(task => task_ids.has(task.id)).map(item => item.id);

                    this.array_options = {...this.array_options, level_id: response.data.level_id, area_id: response.data.area_id, task_id: response.data.task_id}
                }

            } else {
                this.error_handling(response)
            }

            this.loader()

            return response.data
        },

        async fill_data(data) {
            console.log(data);
            this.array_options = data
        },

        async getReport() {

            if(!this.form_data.status_id.length)
            {
                this.notyfMesg('No status selected', 'error')
                return
            }
            
            const form_data = {
                standard_report_id: this.standard_report_id,
                headers: this.daily_assignment_rooms_table,
                headers_2: this.daily_assignment_rooms_table_2,
                params: this.form_data
            }

            this.loader(true)

            const response = await this.post('search_standard_reports', form_data)

            this.loader()

            if (response.status) {
                const base64Data = await this.downloadFile(response, true)
                var blobUrl = URL.createObjectURL(base64Data);
                this.pdfSource = blobUrl
            } else {
                this.error_handling(response)
            }

            // this.loader()
        },

        async removeOldItems(key) {
            this.form_data[key] = this.form_data[key].filter(item => {
                return this.array_options[key].some(array_option => array_option.id === item);
            });
        },

        async handleBuildingChange() {
            this.searching_levels = true
            const { level_id } = await this.getInitialData(false);
            this.array_options.level_id = level_id;
            if(this.array_options.level_id.length)
            {
                this.notyfMesg('Levels were found')
            }
            else
            {
                this.notyfMesg('No Levels found')
            }
            this.removeOldItems('level_id');
            this.searching_levels = false
        },

        async handleLevelChange() {

            if(this.form_data.level_id.length)
            {
                this.searching_areas = true
                const { area_id } = await this.getInitialData(false);
                this.array_options.area_id = area_id;
                if(this.array_options.area_id.length)
                {
                    this.notyfMesg('Areas were found')
                }
                else
                {
                    this.notyfMesg('No Areas found')
                }

                this.searching_areas = false
            }
            else
            {
                this.form_data.area_id = []
            }
            this.removeOldItems('area_id');
        },

    },

    watch: {
        async 'form_data.building_id' ()
        {
            this.debouncedBuildingChange();  
            
        },

        async 'form_data.level_id' ()
        {
            this.debouncedLevelChange();  
        },

        async 'form_data.task_type_id' (val)
        {
            this.array_options.task_id = []

            if(val.length)
            {
                this.form_format[3].disabled = false

                this.getInitialData(false)
            }
            else
            {
                this.form_data.task_id = []
                this.form_format[3].disabled = true
            }
        },
    },  

    created() 
    {
        this.debouncedBuildingChange    =   _.debounce(this.handleBuildingChange, 700)
        this.debouncedLevelChange       =   _.debounce(this.handleLevelChange, 700)
    },

    async mounted() {
        if (this.hasPermissions(['Report Read', 'Report Write'])) {
            this.getInitialData()
            this.breadcrumb[1].arrow = "<span class='slash'>/</span>"
            this.breadcrumb.push({
                name:   this.title_for_breadcrumb,
                href:   '#',
                arrow:  " ",
            });
        }
    },

    
}
</script>
